// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-multi-locations[data-v-266fb097]{max-height:511px;overflow:auto}.widget-multi-locations__location[data-v-266fb097]{border-bottom:1px solid #d6d6d6}", ""]);
// Exports
module.exports = exports;
